import { useIsLargeScreen } from '@bestseller-bit/frontend-community.theme.buying-theme';

type DefaultInputSizes = 'medium' | 'small';

const useDefaultInputSize = (): DefaultInputSizes => {
    const isLargeScreen = useIsLargeScreen();
    return isLargeScreen ? 'medium' : 'small';
};

export { useDefaultInputSize };
